import {useTranslation} from "react-i18next";
import {Button} from "primereact/button";
import React from "react";
import {useNavigate} from "react-router-dom";
import {onChangeLoading, onChangeModalSubscription} from "../../redux/actions/ActionApp";
import {ErrorParse} from "../handlers/ErrorParse";
import {useDispatch} from "react-redux";
import {StripeService} from "../services/StripeService";

/**
 * It checks if the item is a trial, if it is, it closes the modal and displays a notification, if it
 * isn't, it redirects the user to the url
 * @param item - The item that was clicked on.
 * @param response - The response from the server.
 * @param myContext - This is the context of the component.
 * @param dispatch - This is the dispatch function from the redux store.
 */
const redirectPage = (item , response ,  myContext , dispatch, t ) => {
    if (item === "trial") {
        onCloseModal(dispatch);
        myContext.notify6('success' , t('NOTIFICATIONS.TITLE_INFORMATION') , t('NOTIFICATIONS.TRIAL_ACTIVE'));
    } else {
        window.location.replace(response.data);
    }

}

/**
 * It takes in a dispatch function as an argument and returns a function that dispatches an action to
 * change the modal subscription state
 * @param dispatch - This is the dispatch function that is passed to the component by the connect
 * function.
 */
const onCloseModal = (dispatch) => {
    dispatch(onChangeModalSubscription());
}
export default function ItemTablePricing(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isHome, type, time, myContext} = props;
    const dispatch = useDispatch();
    const stripeService = StripeService();
    const costValues = [
        {
            time: 'MONTH',
            cost: {
                ADVANCED: t('MAIN.SPAN_SUSCRIPTION.PLAN.PRICE.ADVANCED'),
                PROFESSIONAL: t('MAIN.SPAN_SUSCRIPTION.PLAN.PRICE.PROFESSIONAL'),
                FULL_ACCESS: t('MAIN.SPAN_SUSCRIPTION.PLAN.PRICE.FULL_ACCESS'),
            },
            priceId: {
                ADVANCED: process.env.REACT_APP_STRIPE_BASIC_M,
                PROFESSIONAL:  process.env.REACT_APP_STRIPE_ADVANCED_M,
                FULL_ACCESS:  process.env.REACT_APP_STRIPE_PROFESSIONAL_M,
            }
        },
        {
            time: 'YEAR',
            cost: {
                ADVANCED: '100',
                PROFESSIONAL: '200',
                FULL_ACCESS: '4.000',
            },
            priceId: {
                ADVANCED: process.env.REACT_APP_STRIPE_BASIC_Y,
                PROFESSIONAL:  process.env.REACT_APP_STRIPE_ADVANCED_Y,
                FULL_ACCESS:  process.env.REACT_APP_STRIPE_PROFESSIONAL_Y,
            }
        }
    ];


    const onNavigate = () => {
        const price = costValues.find(x => x.time === time).priceId[type];
        if (isHome) {
            navigate('/Login');
        } else if ((!isHome && type === 'FREE')) {
            onCheckoutSubscriptionTrial('price_TrialPlan')
        } else {
            onCheckoutSubscription(price)
        }
    }

    const onCheckoutSubscription = (priceId) => {
        dispatch(onChangeLoading());
        stripeService.StripeCheckoutSession({
            "priceId" : priceId,
            "email" : myContext.user.email
        })
            .then(response => {
                redirectPage(type , response , myContext , dispatch, t);
            })
            .catch(error => {
                myContext.notify6('alert' , 'Error' , ErrorParse(error) );
            }).finally(() => {
            dispatch(onChangeLoading());
        })
    }

    const onCheckoutSubscriptionTrial = item => {
        myContext.user.subscription_type = "Trial";
        myContext.user.subscription_status = "Active";
        myContext.setuserActive(myContext.user);
        onCheckoutSubscription(item);
    }

    const returnItemsPrice = (type) => {
        let optLi = [];
        const condition = (i, totals) => {
            if (i <= totals) {
                if (i !== 14) {
                    optLi.push(<li key={'idItems_' + i} className="checked">{t('HOME.PRICING.PLAN_BODY.ITEM_' + i)}</li>)
                }
            }
        }
        const countInitial = type === 'FREE' ? 1 : (type === 'ADVANCED' ? 14 : (type === 'PROFESSIONAL' ? 15 : 19));
        for(let i = countInitial; i <= 21; i++) {
            switch (type) {
                case 'FREE':
                    condition(i, 14);
                    break;
                case 'ADVANCED':
                    condition(i, 14);
                    break;
                case 'PROFESSIONAL':
                    condition(i, 18);
                    break;
                default:
                    condition(i, 21);
                    break;
            }
        }
        return optLi;
    }
    return(
        <div className="plan">
            <div className="plan__container" key={'item' + costValues.find(x => x.time === time).priceId[type]} name={type}>
                <div className="plan__header">
                    <h4>{t('HOME.PRICING.TITLES.' + type)}</h4>
                    {
                        type !== 'FREE' ?
                            <p>$ <span> {costValues.find(x => x.time === time).cost[type]}</span> /{t('PLAN_MODAL.' + time)}</p> :
                            <></>
                    }

                    {
                        type === 'PROFESSIONAL' ?
                            <div className="recommended">
                                {t('HOME.PRICING.RECOMMENDED')}
                            </div> : <></>
                    }
                </div>
                <div className="plan__body">
                    <ul>
                        {
                            type !== 'FREE' ?
                                <li className="checked">{t('HOME.PRICING.PLAN_BODY.ITEM_PLUS_' + (type ===  'ADVANCED' ? 'FREE' :(type === 'PROFESSIONAL' ? 'ADVANCED' : 'PROFESSIONAL')))}</li>
                                : <></>
                        }
                        {
                            type ===  'ADVANCED' || type ===  'PROFESSIONAL' || type ===  'FULL_ACCESS' ?
                                <li className="checked">{t('HOME.PRICING.PLAN_BODY.ITEM_14_' + (type ===  'ADVANCED' ? 'ADVANCED' : (type ===  'PROFESSIONAL' ? 'PROFESSIONAL' : 'FULL_ACCESS')))}</li>
                                :
                                <></>
                        }
                        {returnItemsPrice(type)}
                        {
                            type === 'FREE' ?
                                <li className="checked">{t('HOME.PRICING.PLAN_BODY.ITEM_14')}</li> : <></>
                        }
                        {
                            type === 'FREE' ?
                                <li className="checked">{t('HOME.PRICING.PLAN_BODY.ITEM_PLUS_FREE_2')}</li>
                                : <></>
                        }
                    </ul>
                    {
                        !isHome && (myContext && myContext.user?.subscription_type !== 'None' && type === 'FREE') && myContext && myContext.user?.subscription_trialconsumed !== 'True' ?
                            <></> : ((myContext && myContext.user?.subscription_type === type && myContext.user?.subscription_status !== 'canceled') ?
                                <></> : <Button label={t('HOME.PRICING.BUTTON_SELECT_PLAN')} onClick={onNavigate}
                                                className="p-button p-button-outlined p-button-success"/>)
                    }
                </div>
            </div>
        </div>
    )
}